import {remCalc} from '_themeUtils'
import footerSection from './partials/footer-section'
import footerSocials from './partials/footer-socials'
import footerLegal from './partials/footer-legal'

const footerBase = {
    Footer: {
        baseStyle: () => ({
            footer: {
                gap: 0,
            },
            main: {
                pt: {md: 'spacing.10'},
                pb: 'spacing.10',
                px: {md: 'spacing.5', xl: 'spacing.28'},
                borderTop: {md: `solid ${remCalc(1)}`},
                borderTopColor: {md: 'color.border.footer.default'},
                gap: 'spacing.10',
            },
            bottom: {
                py: 'spacing.6',
                px: {base: 'spacing.5', xl: 'spacing.28'},
                borderTop: `solid ${remCalc(1)}`,
                borderTopColor: 'color.border.footer.default',
                gap: 'spacing.6',
                align: {base: 'center', md: 'flex-start'},
                textAlign: {base: 'center', md: 'left'},
            },
            newsletterContainer: {
                gap: 'spacing.6',
                order: {base: 2, md: 1},
                px: {base: 'spacing.5', md: 0},
            },
            sectionTitle: {
                textStyle: 'paragraphXl',
                fontWeight: 400,
            },
            sectionsGrid: {
                templateColumns: 'repeat(12, 1fr)',
                gap: {md: 'spacing.8'},
                order: {base: 1, md: 2},
            },
            sectionsGridItem: {
                colSpan: {base: 12, md: 3},
            },
        }),
    },
}

const footer = {
    ...footerBase,
    ...footerSection,
    ...footerSocials,
    ...footerLegal,
}

export default footer
